import React, { useState, useRef, useEffect } from 'react'
import Image from 'components/image'
import { getSanityMediaUrl } from 'helpers/get-sanity-media-url'
import RichText from "components/rich-text"
import { PortableText } from "@portabletext/react"
import { richTextComponents } from "components/rich-text-new"
import richTextData from "components/rich-text-new/data"
const MediaBlock = ({ data }) => {
    const ref = useRef(null)
    const [showVideo, setShowVideo] = useState(false)

    useEffect(() => {
        if (!data?.video || !ref.current) return

        let timer

        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    timer = setTimeout(() => {
                        setShowVideo(true)
                    }, 1000)
                } else {
                    clearTimeout(timer)
                    setShowVideo(false)
                }
            },
            {
                threshold: 0.3,
            }
        )

        observer.observe(ref.current)

        return () => {
            observer.disconnect()
            clearTimeout(timer)
        }
    }, [data?.video])

    const imagePlacement = data?.imagePlacement
    const iconPlacement = data?.iconPlacement
    const titlePlacement = data?.titlePlacement || 'default'
    const imageSize = data?.imageSize
    const video = data?.video
    const style = data?.style || 'default'
    const titleColor = data?.titleColor?.hex;
    const descriptionColor = data?.descriptionColor?.hex;
    const backgroundColor = data?.backgroundColor?.hex;
    const imageColSpan = data?.imageColSpan || 6;
    const contentColSpan = data?.contentColSpan || 6;
    const fontStyles = data?.fontStyles || 'default';
    const imageAspectRatio = data?.imageAspectRatio || '1/1';
    const verticalAlignment = data?.verticalAlignment;
    const getStyleClass = () => {
        const styles = {
            "default": "",
            "connected": "media-block--connected",
        }
        return styles[style] || styles.default;
    }

    let getFontStylesClass = () => {
        const fontStylesMap = {
            "default": "",
            "smallerText": "media-block--smaller-text",
        }
        return fontStylesMap[fontStyles] || '';
    }
    let getIconClass = () => {
        let positions = {
            left: 'media-block__icon--left',
            right: 'media-block__icon--right',
            top: 'media-block__icon--top',
            bottom: 'media-block__icon--bottom',
        }
        return positions[iconPlacement || 'left']
    }

    let getVerticalAlignmentClass = () => {
        if (!verticalAlignment) return '';
        const alignmentMap = {
            'flex-start': 'media-block--align-flex-start',
            'center': 'media-block--align-center',
            'flex-end': 'media-block--align-flex-end',
        };
        return alignmentMap[verticalAlignment] || '';
    }

    const hasDynamicTitle = data?.dynamicTitle && Array.isArray(data.dynamicTitle) && data.dynamicTitle.length > 0
    const hasTitle = data?.title || hasDynamicTitle

    let getImageClass = () => {

        let size = {
            normal: 'media-block__image--normal',
            big: 'media-block__image--big',
        }
        if (imageSize === "big") return size['big']

        let positions = {
            left: 'media-block__image--left',
            right: 'media-block__image--right',
        }

        let noImage = !data?.image ? 'media-block__image--no-image' : '';
        return positions[imagePlacement || 'left'] + ' ' + size[imageSize || 'normal'] + ' ' + noImage;
    }


    return (
        <div className="media-block__wrapper" ref={ref} >
            {titlePlacement === 'above' && hasTitle && (
                <div className="media-block__title-row container">
                    {hasDynamicTitle ? (
                        <div className="media-block__title" style={{ '--title-color': titleColor }}>
                            <PortableText value={data.dynamicTitle} components={richTextComponents(richTextData.NoStyle)} />
                        </div>
                    ) : (
                        <p className="media-block__title" style={{ '--title-color': titleColor }}>{data?.title}</p>
                    )}
                </div>
            )}
            <div
                className={`media-block container ${getImageClass()} ${getStyleClass()} ${getFontStylesClass()} ${getVerticalAlignmentClass()} ${titlePlacement === 'above' ? 'media-block--title-above' : ''}`}
                style={{ '--image-col-span': imageColSpan, '--content-col-span': contentColSpan, '--background-color': backgroundColor, '--image-aspect-ratio': imageAspectRatio }}
            >
                {data?.image && (
                    <div className="media-block__image">
                        {video && showVideo && (
                            <video
                                src={getSanityMediaUrl(video)}
                                className="features-media__video"
                                autoPlay
                                loop
                                muted
                                playsInline
                            />
                        )}
                        <Image image={data?.image} />
                    </div>
                )}
                <div className="media-block__content">
                    {((hasTitle && titlePlacement === 'default') || data?.icon) && (
                        <div className={`media-block__header ${getIconClass()}`}>
                            {data?.icon && (
                                <div className="media-block__icon">
                                    <Image image={data?.icon} />
                                </div>
                            )}
                            {titlePlacement === 'default' && hasTitle && (
                                hasDynamicTitle ? (
                                    <div className="media-block__title" style={{ '--title-color': titleColor }}>
                                        <PortableText value={data.dynamicTitle} components={richTextComponents(richTextData.NoStyle)} />
                                    </div>
                                ) : (
                                    <p className="media-block__title" style={{ '--title-color': titleColor }}>{data?.title}</p>
                                )
                            )}
                        </div>
                    )}
                    <div className="media-block__description" style={{ '--description-color': descriptionColor }}>
                        {data?.richDescription && !data?.description && (
                            <RichText data={data?.richDescription} />
                        )}
                        {data?.description && (
                            <p className="media-block__description-text">{data?.description}</p>
                        )}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default MediaBlock